/**
 * Interaction states shared by every focusable control.
 * The pink signature is never used for focus — that would be a 5th usage and dissolve the rule.
 */

export const focusRing =
  "outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink";

/**
 * Reserved for controls sitting ON a dark surface. `outline-offset` draws the ring OUTSIDE the
 * element, so an ink button on a light page still needs the ink ring above — not this one.
 */
export const focusRingOnInk =
  "outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-surface-content";

export const roundAddButton =
  "inline-flex items-center justify-center shrink-0 w-11 h-11 rounded-pill bg-line-border text-ink transition duration-hover hover:bg-line-dashed";
